module.exports = __webpack_public_path__ + "static/img/IMG_20240326_161405.cdd5a823.jpg";